export default __webpack_public_path__ + "static/media/12.241048f1.jpg";